import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/overview")({
  component: lazyRouteComponent(() => import("@/pages/admin/Overview")),
});
